var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTetherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 88,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 47a151 151 0 0 1-20 0c-19-1-33-4-33-8s14-7 33-8v13a146 146 0 0 0 20 0V31c19 1 33 4 33 8s-14 7-33 8Zm0-17V18h27V0H11v18h27v12C16 31 0 35 0 40s16 9 38 10v38h20V50c22-1 38-5 38-10s-16-9-38-10Z",
    fill: "#058BD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTetherIcon);
export default __webpack_public_path__ + "static/media/tether-icon.5c630c1eb0cbcac871cd30b00cf91301.svg";
export { ForwardRef as ReactComponent };